import { Nullable } from '@cast/leadcast-types';
import { z } from 'zod';

const ynu = ['yes', 'no', 'unknown'] as const;
export type YesNoUnknownType = (typeof ynu)[number];

export const yesNoUnknown = z.enum(ynu).transform(getBooleanFromYesNoUnknown);

export function getYesNoUnknownValue(value: Nullable<boolean>): YesNoUnknownType {
  if (value) {
    return 'yes';
  } else if (value === false) {
    return 'no';
  } else {
    return 'unknown';
  }
}

function getBooleanFromYesNoUnknown(value: YesNoUnknownType): Nullable<boolean> {
  if (value === 'yes') {
    return true;
  } else if (value === 'no') {
    return false;
  } else {
    return null;
  }
}
